<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>
            G H Raisoni Memorial Nanded District Chess Selection Tournament 2025
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img
      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
    />
  </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center mb-5">
      <h2>
        <span
          >G H Raisoni Memorial Nanded District Chess Selection Tournament
          2025</span
        >
      </h2>
    </div>
    <div class="row justify-content-between">
      <div class="col-md-12">
        <p><strong>Event Dates:</strong> May – 12th May 2025</p>
        <p><strong>Venue:</strong> Nanded, Maharashtra</p>
        <p><strong>Event Type:</strong> District Selection Tournament</p>
        <p>
          <strong>Organized by:</strong> G H Raisoni Sports and Cultural
          Foundation & Kalpana Prakash Welfare Foundation
        </p>

        <p>
          <strong>Overview</strong>
        </p>
        <p>
          We are proud to share the highlights of the G H Raisoni Memorial
          Nanded District Chess Selection Tournament 2025, successfully
          conducted on May 12th in Nanded. This prestigious event witnessed the
          participation of young and dynamic chess enthusiasts from across the
          district, showcasing their talent and love for the game.
        </p>

        <p>
          With intense competition across all age categories, the tournament
          served as the official selection platform for district-level
          representation in upcoming state events. The atmosphere was charged
          with enthusiasm, concentration, and mutual respect—true to the spirit
          of chess.
        </p>

        <h6>Key Highlights:</h6>
        <ul class="list-style list-style1 mb-3">
          <li>
            <strong> Over 180 participants:</strong> across various age groups.
          </li>

          <li>
            Fair and smooth conduct of matches under the guidance of FIDE-rated
            arbiters.
          </li>

          <li>
            Top performers qualified to represent Nanded district at the
            state-level championships.
          </li>
          <li>
            Certificate distribution and prize ceremony held in the presence of
            notable dignitaries and organizers.
          </li>
          <li>
            Parents and spectators lauded the event’s organization, discipline,
            and encouragement of young talent.
          </li>
        </ul>
      </div>
      <div class="col-md-12">
        <div class="lightBox--gallery">
          <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-1.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-1.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-1.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"  alt="GHRSCF"

                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-2.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-2.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-2.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"  alt="GHRSCF"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-3.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-3.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-3.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"  alt="GHRSCF"
                  />
                </div>
              </a>
            </li>

            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-4.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-4.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-4.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"  alt="GHRSCF"
                  />
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
